import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/searchGeblokkeerdeWeken'
import type { GeblokkeerdeWekenSearch } from '../types/GeblokkeerdeWekenSearch'

export { useGeblokkeerdeWekenSearchStore }

const useGeblokkeerdeWekenSearchStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<GeblokkeerdeWekenSearch['query']>>(
  (set) => ({
    query: initialState.query,
    storeQuery: (query) =>
      set((state) => ({ query: { ...state.query, ...query } })),
  }),
)
